import * as Yup from "yup";
import { baseUserFields } from "../shared/validation";

const FormAddUserValidationSchema = Yup.object().shape({
  ...baseUserFields,
  enabled: Yup.boolean().default(true),
  emailVerified: Yup.boolean().default(false),
});

export default FormAddUserValidationSchema;
